import { FirmInfoType } from '@/components/settings-page/platformSettings/firmInfo';
import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { formatUserPhoneNumber } from '@/components/settings-page/users/firmTable/tableBody';
import { getCacheBustedFileUrl } from '@/components/settings-page/utils';
import { Image as PdfImage, Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';

interface UpdatesSummaryPDFTemplateFooterProps {
  theme: DefaultTheme;
  firmInfoData: FirmInfoType;
  templateStylingData: ITemplateStylingSettings;
}

export const UpdatesSummaryPDFTemplateFooter = ({ theme, firmInfoData, templateStylingData }: UpdatesSummaryPDFTemplateFooterProps) => {
  const { firmName, address, website, phone, email } = firmInfoData || {};
  const { streetAddress, city, state, zipCode } = address || {};
  const hasPhone = phone && Object.values(phone || {})?.length > 0;
  const phoneNumber = hasPhone ? formatUserPhoneNumber(phone.countryCode, phone.number) : '';

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        bottom: 0,
        left: '2.5%',
        right: '2.5%',
        padding: '0 10px',
        fontSize: '10px',
        fontFamily: 'Open Sans',
        color: theme.font.weak,
        height: '70px',
        width: '95%',
        borderTop: `1px solid ${theme.border.base}`
      }}
      fixed
    >
      <View>
        <PdfImage
          src={getCacheBustedFileUrl(templateStylingData?.logo)}
          style={{
            maxWidth: '80px',
            maxHeight: '80px',
            objectFit: 'contain'
          }}
        />
      </View>
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text style={{ color: theme.font.base, fontWeight: 700 }}>{firmName}</Text>
        {streetAddress && <Text>{streetAddress}</Text>}
        {(city || state || zipCode) && <Text>{`${city ? ` ${city},` : ''} ${state || ''} ${zipCode || ''}`}</Text>}
      </View>
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {website && <Text>{website}</Text>}
        {email && <Text>{email}</Text>}
        {hasPhone && <Text>Office: {`${phoneNumber}`}</Text>}
      </View>
    </View>
  );
};
